import styled from 'styled-components';
import cssIngka from '@ingka/variables/colours-css';

/* WCAG 2.5.8: minimum touch target size is 24×24 CSS px */
export const ItemFamily = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-image: url('${(props) => textToColor(props.color)}');
  background-size: 100%;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  filter: drop-shadow(#999 0.01rem);
  min-width: 24px;
  min-height: 24px;
  width: 24px;
  height: 24px;
  margin-top: 10px;
  margin-left: 5px;
  cursor: pointer;
  padding: 0;
  &:first-child {
    margin-left: 0;
  }
  &:focus-visible {
    outline: 2px solid ${cssIngka.colourStaticIkeaBrandBlue};
    outline-offset: 2px;
  }
`;

export const ItemFamilyList = styled.div`
  display: inline-block;
`;

const textToColor = (textColor: string | undefined) => {
  const imagePath = `https://www.ikea.com/global/assets/customer-service/returns-claims/spareparts/images/dots/${textColor}.png`;
  return textColor ? imagePath : '';
};

export const StyledColorDot = styled.span`
  display: inline-block;
  position: absolute;
  background-image: url('${(props) => textToColor(props.color)}');
  background-size: 100%;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  margin-left: 70px;
`;

export const AvailableOptionsWrapper = styled.div`
  margin: 10px 0;
  width: 100%;
`;
